export const API_BASE =
  process.env.REACT_APP_API_BASE || "https://market-dashboard-5yoy.onrender.com";

export const apiUrl = (path) =>
  `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;